import Faye from './Faye';
import { MESSAGE_ENDPOINT } from '~/config';

const faye = window.faye = window.faye || new Faye(MESSAGE_ENDPOINT);

const FayeService = {
	subscribe: (channel, cb) => {
		let subscription = faye.subscribe(channel, cb);
		return () => subscription.cancel();
	}
};

export default FayeService;
